<div class="min-h-[30rem] p-4 bg-[var(--brand-gray-bg)] flex flex-col items-center justify-center text-center">
  <h1 class="text-3xl font-bold mb-4" style="color: var(--brand-indigo);">Página no encontrada</h1>
  <p class="text-base mb-6" style="color: rgba(0,0,0,0.65); max-width: 28rem;">
    La página que buscás no existe o cambió de dirección. Probá desde el inicio o escribinos y te ayudamos.
  </p>
  <div class="flex flex-col sm:flex-row gap-3">
    <a routerLink="/" class="inline-flex items-center justify-center rounded-full px-6 py-3 font-semibold"
      style="border: 2px solid var(--brand-indigo); color: var(--brand-indigo);">
      Volver al inicio
    </a>
    <button type="button" (click)="enviarWhatsApp()"
      class="inline-flex items-center gap-2 justify-center rounded-full px-6 py-3 font-semibold text-white"
      style="background: var(--brand-whatsapp);">
      <i class="fab fa-whatsapp" aria-hidden="true"></i>
      <span>Consultar por WhatsApp</span>
    </button>
  </div>
</div>
